import { Component, EventEmitter, Input, Output } from '@angular/core';

import {
  ITemplateWithHierarchy,
  ListItem,
  TableCellData,
  TableCellKinds,
  TableColumn,
  TableColumnWidths,
} from '@site-mate/dashpivot-shared-library';

import { FormBaseComponent } from 'app/form/form-components/form-base.component';
import { FormService } from 'app/form/form.service';
import { FormTableCell } from 'app/form-fields/table/edit-cells/table-cell';
import { TmpI18NService } from 'app/i18n/tmp-i18n.service';
import { FieldWeb } from 'app/shared/model/item.model';
import { AppUtilService } from 'app/shared/service/app-util.service';
import { ToastrService } from 'app/shared/service/toastr.service';

import { TableColumnService } from '../service/table-column-service';

@Component({
  selector: 'cc-form-table-column',
  templateUrl: 'form-table-column.component.html',
  styleUrls: ['../../../form/form-components/form-component.scss', 'form-table.component.scss'],
})
export class FormTableColumnComponent extends FormBaseComponent {
  @Input() formId: string;
  @Input() formPath: string;
  @Input() parentId: string;
  @Input() kind: TableCellKinds;
  @Input() column: TableCellData;
  @Input() rowIndex: number;
  @Input() columnIndex: number;
  @Input() listContent: ListItem[];
  @Input() columnDescription: string;
  @Input() model: FieldWeb;
  @Input() template: ITemplateWithHierarchy;

  @Output() readonly onChangeTableField = new EventEmitter();
  @Output() readonly onChangePotentialFormulaField = new EventEmitter();

  uploading = [];
  tableCell: FormTableCell;
  headerColumn: TableColumn;
  cellName: string;
  popoverMessage: string;
  readonly tableColumnWidths = TableColumnWidths;

  constructor(
    protected readonly appUtilService: AppUtilService,
    protected readonly formService: FormService,
    protected readonly toastrService: ToastrService,
    private readonly tableColumnService: TableColumnService,
    private readonly i18nService: TmpI18NService,
  ) {
    super(appUtilService, formService);
  }

  ngOnInit() {
    this.headerColumn = this.model?.columns?.[this.columnIndex];
    this.cellName = `column-${this.rowIndex}-${this.columnIndex}`;
    this.popoverMessage = this.i18nService.getMessage('prefilledCellPopover');
  }

  onPreviewAction(warningKey: string) {
    this.toastrService.warnByKey(warningKey);
  }

  onSign(column) {
    this.tableColumnService.onSignColumn({
      column,
      itemId: this.model.id,
      formId: this.formId,
      onSigned: this.onChangeField.bind(this),
    });
  }

  onManualSign(column) {
    this.tableColumnService.onManualSignColumn({
      column,
      itemId: this.model.id,
      formId: this.formId,
      onSigned: this.onChangeField.bind(this),
    });
  }

  onChangeField() {
    this.onChangeTableField.emit();
  }

  onChangeFormulaField() {
    this.onChangePotentialFormulaField.emit({ colIndex: this.columnIndex, rowIndex: this.rowIndex });
  }

  async onUpload(event) {
    await this.tableColumnService.handleAttachmentUploadToColumn({
      event,
      itemId: this.model.id,
      column: this.column,
      uploadingAttachments: this.uploading,
      formId: this.formId,
    });

    this.onChangeField();
  }

  deleteAttachment(attachment) {
    this.tableColumnService.onRemoveTableColumnAttachment({
      attachment,
      attachments: this.column.attachments,
      onDelete: this.onChangeField.bind(this),
    });
  }
}
